import Loadable from '@/common/lazy/Loadable';
import imports from '@/routing/imports';
import React from 'react';

const CasinoJackpots = Loadable({ loader: imports.casinoVegas, exp: Exp => Exp.Jackpots });

function JackpotsModule() {
    return <CasinoJackpots columnView />;
}

export default JackpotsModule;
